import { message, Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import {
    ModalItem,
    Form,
    FormItem,
    ErrorItem,
    ButtonItem
} from "../../../../../Components/Items";
import moment from "moment";
import InputItem from "../../../../../Components/InputItem";

moment.locale("es");


class CorreoEmpresa extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        pdf: null,
    };
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "empresas/cambiarCorreoEmpresa",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Correo de la empresa actualizado");
                } else if (res.data.success === 1) {
                    message.error(res.data.message ? res.data.message : "Error al actualizar el correo de la empresa");
                } else {
                    message.error("Sucedio un error y no se pudo entregar");
                }
                this.formRef.current.resetFields();
                this.setState({ loading: false });
                this.cerrarCorreoEmpresa();
            });
    }
    cerrarCorreoEmpresa() {
        this.props.cerrarCorreoEmpresa();
    }
    render() {
        return (
            <ModalItem
                title="Correo Empresa"
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarCorreoEmpresa.bind(this)}
                paddingTop
            >
                <Form
                    ref={this.formRef}
                    name="correoEmpresa"
                    layout
                    width={700}
                    onCancel={this.cerrarCorreoEmpresa.bind(this)}
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                >
                    <FormItem
                        label="Correo"
                        name="correo"
                        pattern
                        max={200}
                        email
                        margin
                    >
                        <InputItem placeholder="Correo" />
                    </FormItem>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: 20,
                            marginBottom: 10,
                        }}
                    >
                        <Space>
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Guardar
                            </ButtonItem>
                            <ButtonItem
                                type="primary"
                                blanco
                                onClick={this.cerrarCorreoEmpresa.bind(this)}
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Regresar
                            </ButtonItem>
                        </Space>
                    </div>
                </Form>
            </ModalItem>
        );
    }
}


export default CorreoEmpresa;
